import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiSignup } from "../api";
import { AppearanceSelect } from "../components/AppearanceSelect";
import { AppBrandTagline } from "../components/AppLogo";
import { PasswordField } from "../components/PasswordField";
import { useAuth } from "../SessionContext";
import { OAuthProviderButtons } from "../components/OAuthProviderButtons";
import { useOAuthProviders } from "../useOAuthProviders";

export function SignupPage() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const oauthProviders = useOAuthProviders();

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await apiSignup(email, password);
      await refresh();
      navigate("/", { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Signup failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="layout narrow">
      <div className="auth-appearance-row">
        <AppearanceSelect id="appearance-signup" />
      </div>
      <h1>Create account</h1>
      <AppBrandTagline />
      <p className="muted">Use a strong password (10+ characters).</p>
      <form className="card" method="post" onSubmit={onSubmit}>
        <label>
          Email
          <input
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.currentTarget.value)}
            required
          />
        </label>
        <PasswordField
          label="Password"
          value={password}
          onChange={setPassword}
          autoComplete="new-password"
          required
        />
        {error ? <p className="error">{error}</p> : null}
        <button type="submit" disabled={busy}>
          {busy ? "Creating…" : "Create account"}
        </button>
      </form>
      <OAuthProviderButtons
        googleEnabled={oauthProviders.google}
        appleEnabled={oauthProviders.apple}
        loading={oauthProviders.loading}
        error={oauthProviders.error}
        ariaLabel="Social sign-up"
      />
      <p className="muted">
        <Link to="/login">Already have an account?</Link>
      </p>
    </div>
  );
}
